export var BeaconEvents;
(function (BeaconEvents) {
    BeaconEvents[BeaconEvents["presentationHeartbeat"] = 0] = "presentationHeartbeat";
    BeaconEvents[BeaconEvents["attendeeReady"] = 1] = "attendeeReady";
    BeaconEvents[BeaconEvents["attendeeIframeReady"] = 2] = "attendeeIframeReady";
    BeaconEvents[BeaconEvents["recordingStatus"] = 3] = "recordingStatus";
    BeaconEvents[BeaconEvents["shareScreen"] = 4] = "shareScreen";
    BeaconEvents[BeaconEvents["stopAllShareScreen"] = 5] = "stopAllShareScreen";
})(BeaconEvents || (BeaconEvents = {}));
// We assign hard coded numbers here to maintain backwards
// compatability with existing data which used these numbers
export var PlayerActions;
(function (PlayerActions) {
    PlayerActions[PlayerActions["next"] = 0] = "next";
    PlayerActions[PlayerActions["prev"] = 1] = "prev";
    PlayerActions[PlayerActions["gotoSlide"] = 2] = "gotoSlide";
    PlayerActions[PlayerActions["jumpToAnim"] = 10] = "jumpToAnim";
    PlayerActions[PlayerActions["animateTransform"] = 30] = "animateTransform";
    PlayerActions[PlayerActions["authCloudFront"] = 27] = "authCloudFront";
})(PlayerActions || (PlayerActions = {}));
export var DatatrackDataTypes;
(function (DatatrackDataTypes) {
    DatatrackDataTypes[DatatrackDataTypes["BeaconControl"] = 0] = "BeaconControl";
    DatatrackDataTypes[DatatrackDataTypes["BeaconEvent"] = 1] = "BeaconEvent";
    DatatrackDataTypes[DatatrackDataTypes["PlayerControl"] = 2] = "PlayerControl";
    DatatrackDataTypes[DatatrackDataTypes["PlayerEvent"] = 3] = "PlayerEvent";
    DatatrackDataTypes[DatatrackDataTypes["Chat"] = 4] = "Chat";
})(DatatrackDataTypes || (DatatrackDataTypes = {}));
export class DatatrackData {
    constructor() {
        this.timestamp = new Date();
    }
    type;
    timestamp;
}
export class ControlData extends DatatrackData {
    constructor(action, param) {
        super();
        this.action = action;
        this.param = param;
    }
    action;
    param;
}
export var BeaconActions;
(function (BeaconActions) {
    BeaconActions[BeaconActions["startPresentation"] = 0] = "startPresentation";
    BeaconActions[BeaconActions["startScreenShare"] = 1] = "startScreenShare";
    BeaconActions[BeaconActions["stopPresentation"] = 2] = "stopPresentation";
})(BeaconActions || (BeaconActions = {}));
export class BeaconControlData extends ControlData {
    constructor(action, param) {
        super(action, param);
        this.type = DatatrackDataTypes.BeaconControl;
    }
}
export class PlayerControlData extends ControlData {
    constructor(action, param) {
        super(action, param);
        this.type = DatatrackDataTypes.PlayerControl;
    }
}
export var PlayerEvents;
(function (PlayerEvents) {
    PlayerEvents[PlayerEvents["onLoadingStart"] = 0] = "onLoadingStart";
    PlayerEvents[PlayerEvents["onLoadingEnd"] = 1] = "onLoadingEnd";
    PlayerEvents[PlayerEvents["onSlideChange"] = 2] = "onSlideChange";
    PlayerEvents[PlayerEvents["onMovToNxtAnim"] = 3] = "onMovToNxtAnim";
    PlayerEvents[PlayerEvents["onMovToPrvAnim"] = 4] = "onMovToPrvAnim";
    PlayerEvents[PlayerEvents["onPlayingStart"] = 5] = "onPlayingStart";
    PlayerEvents[PlayerEvents["onPlayingEnd"] = 6] = "onPlayingEnd";
    PlayerEvents[PlayerEvents["onProgressChange"] = 7] = "onProgressChange";
    PlayerEvents[PlayerEvents["onSlideEnd"] = 8] = "onSlideEnd";
    PlayerEvents[PlayerEvents["onSldOutlineLoad"] = 9] = "onSldOutlineLoad";
    PlayerEvents[PlayerEvents["initaliseSettings"] = 10] = "initaliseSettings";
    PlayerEvents[PlayerEvents["mouseEvent"] = 11] = "mouseEvent";
    PlayerEvents[PlayerEvents["statusEvent"] = 12] = "statusEvent";
    PlayerEvents[PlayerEvents["swipeVertical"] = 13] = "swipeVertical";
})(PlayerEvents || (PlayerEvents = {}));
class EventData extends DatatrackData {
    constructor(event, param) {
        super();
        this.event = event;
        this.param = param;
    }
    event;
    param;
}
export class PlayerEventData extends EventData {
    constructor(event, param) {
        super(event, param);
        this.type = DatatrackDataTypes.PlayerEvent;
    }
}
var PlayerModes;
(function (PlayerModes) {
    PlayerModes[PlayerModes["INTERACTIVE"] = 0] = "INTERACTIVE";
    PlayerModes[PlayerModes["NON_INTERACTIVE"] = 1] = "NON_INTERACTIVE";
})(PlayerModes || (PlayerModes = {}));
var HubDeviceModes;
(function (HubDeviceModes) {
    HubDeviceModes["desktop"] = "desktop";
    HubDeviceModes["tablet"] = "tablet";
    HubDeviceModes["mobile"] = "mobile";
})(HubDeviceModes || (HubDeviceModes = {}));
export var PDFMessageTypes;
(function (PDFMessageTypes) {
    PDFMessageTypes["LOAD_FILE"] = "LOAD_FILE";
    PDFMessageTypes["IFRAME_LOADED"] = "IFRAME_LOADED";
    PDFMessageTypes["PDF_PAGE_LOADED"] = "PDF_PAGE_LOADED";
    PDFMessageTypes["PLAYER_MODE"] = "PLAYER_MODE";
    PDFMessageTypes["PLAYER_CONTROL"] = "PLAYER_CONTROL";
    PDFMessageTypes["PPZ_TRANSFORM"] = "PPZ_TRANSFORM";
    PDFMessageTypes["SET_PRESENTATION_STATE"] = "SET_PRESENTATION_STATE";
    PDFMessageTypes["SET_VISIBLE_PAGES"] = "SET_VISIBLE_PAGES";
    PDFMessageTypes["SET_PRESENTATION_META"] = "SET_PRESENTATION_META";
    PDFMessageTypes["PAGE_CHANGE"] = "PAGE_CHANGE";
    PDFMessageTypes["SET_CONTENT_ACCESS_TOKEN"] = "SET_CONTENT_ACCESS_TOKEN";
    PDFMessageTypes["DOCUMENT_LOADED"] = "DOCUMENT_LOADED";
    PDFMessageTypes["NAVIGATE_PREVIOUS"] = "NAVIGATE_PREVIOUS";
    PDFMessageTypes["NAVIGATE_NEXT"] = "NAVIGATE_NEXT";
    PDFMessageTypes["NAVIGATE_PAST_FIRST"] = "NAVIGATE_PAST_FIRST";
    PDFMessageTypes["NAVIGATE_PAST_LAST"] = "NAVIGATE_PAST_LAST";
    PDFMessageTypes["PAUSE_VIDEOS"] = "PAUSE_VIDEOS";
    PDFMessageTypes["SWIPE_VERTICAL"] = "SWIPE_VERTICAL";
    PDFMessageTypes["SHOW_SEARCH"] = "SHOW_SEARCH";
    PDFMessageTypes["SHOW_MY_CONTENT"] = "SHOW_MY_CONTENT";
    PDFMessageTypes["CURRENT_CONTENT_INFO"] = "CURRENT_CONTENT_INFO";
    PDFMessageTypes["TOGGLE_HIGHLIGHTER"] = "TOGGLE_HIGHLIGHTER";
    PDFMessageTypes["TOGGLE_NOTATIONS"] = "TOGGLE_NOTATIONS";
    PDFMessageTypes["TOGGLE_COORDINATE_MODE"] = "TOGGLE_COORDINATE_MODE";
    PDFMessageTypes["SEND_NOTATION_COORDINATE"] = "SEND_NOTATION_COORDINATE";
    PDFMessageTypes["UPDATE_NOTATIONS"] = "UPDATE_NOTATIONS";
    PDFMessageTypes["SET_EDIT_NOTATION"] = "SET_EDIT_NOTATION";
    PDFMessageTypes["SYNC_CURRENT_ACTIVE_NOTATION"] = "SYNC_CURRENT_ACTIVE_NOTATION";
    PDFMessageTypes["ANALYTICS"] = "ANALYTICS";
    PDFMessageTypes["RELOAD_IFRAME"] = "RELOAD_IFRAME";
    PDFMessageTypes["SET_SEARCH_HIGHLIGHT"] = "SET_SEARCH_HIGHLIGHT";
})(PDFMessageTypes || (PDFMessageTypes = {}));
export var PlayerEventSource;
(function (PlayerEventSource) {
    PlayerEventSource["APP"] = "APP";
    PlayerEventSource["PUBLISHER"] = "PUBLISHER";
    PlayerEventSource["MEETING"] = "MEETING";
})(PlayerEventSource || (PlayerEventSource = {}));
// hooks
export { default as useOnlineStatus } from './hooks/useOnlineStatus/useOnlineStatus';
export { default as useInterval } from './hooks/useInterval/useInterval';
export { default as usePresentationPlayerContext, } from './hooks/usePresentationPlayerContext/usePresentationPlayerContext';
export * from './types/cacheDB';
export * from './types/workerChannel';
export * from './types/auth';
export { PresentationContext, usePresentationContext, } from './state/context/PresentationPlayer/PresentationContext';
export { default as PresentationPlayerProvider, } from './state/context/PresentationPlayerContext/PresentationPlayerContext';
export { PRESENTATION_CONTEXT } from './state/context/PresentationPlayer/types';
// util
export { reachabilityMonitor } from './hooks/useOnlineStatus/useOnlineStatus';
export { default as WebLinking } from './util/WebLinking';
export { nonSelectableElementHook } from './hooks/css/css';
export * from './util/Regex';
export * from './types/Platform';
//# sourceMappingURL=index.js.map